window.addEventListener("load", () => {
  class ChefmasterChat {
    constructor(rootSelector) {
      this.root = document.querySelector(rootSelector);
      if (!this.root) return;

      this.handleBtn = this.root.querySelector(".chefmaster-chat__handle");
      this.popup = this.root.querySelector(".chefmaster-chat__popup");
      this.chatContainer = this.popup.querySelector(".chefmaster-chat__center__chat");
      this.loading = this.chatContainer.querySelector(".chefmaster-chat__popup__chat__message--loading");

      this.templateMessage = this.chatContainer.querySelector(".chefmaster-chat__popup__chat__message--template");
      this.templateFrom = this.chatContainer.querySelector(".chefmaster-chat__popup__chat__from--template");

      this.textarea = this.popup.querySelector('textarea[name="input"]');
      this.sendButton = this.popup.querySelector(".chefmaster-chat__center__buttons button");
      this.fileInput = this.popup.querySelector('.chefmaster-chat__center__paperclip input[type="file"]');
      this.fileCount = this.popup.querySelector(".chefmaster-chat__center__paperclip__count");

      this.closeButton = this.popup.querySelector(".chefmaster-chat__popup_exit");

      this.rightImages = this.popup.querySelector(".chefmaster-chat__right__images");

      this.sessionId = this.generateGUID();
      this.pendingImages = []; // Array of { file, element }
      this.fileCount.innerText = "0";

      this.init();
    }

    // --- Initialization ---
    init() {
      this.bindPopupToggles();
      this.bindInputEvents();
      this.bindFileEvents();
      this.startTimestampUpdater();
    }

    // --- Popup Toggle ---
    bindPopupToggles() {
      this.handleBtn.addEventListener("click", () => {
        this.popup.classList.toggle("chefmaster-chat__popup--hidden");
      });

      this.closeButton.addEventListener("click",  () => {
        this.popup.classList.add("chefmaster-chat__popup--hidden");
      })
    }

    // --- Input & Send ---
    bindInputEvents() {
      this.sendButton.addEventListener("click", () => this.sendMessage());
      this.textarea.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.sendMessage();
        }
      });
    }

    async sendMessage() {
      const text = this.textarea.value.trim();
      if (!text && this.pendingImages.length === 0) return;

      this.addMessage(text, true);
      await this.fetchResponse(text);

      this.textarea.value = "";
    }

    // --- Image Upload (Multiple) ---
    bindFileEvents() {
      this.fileInput.setAttribute("multiple", "multiple");
      this.fileInput.addEventListener("change", (event) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        files.forEach((file) => {
          if (!file.type.startsWith("image/")) {
            alert(`${file.name} is not an image file!`);
            return;
          }
          this.addPendingImage(file);
        });

        // Reset input to allow uploading same file again later
        this.fileInput.value = "";
      });
    }

    addPendingImage(file) {
      const imgURL = URL.createObjectURL(file);

      // Create preview container
      const wrapper = document.createElement("div");
      wrapper.classList.add("chefmaster-chat__right__image", "chefmaster-chat__right__image--sending-now");

      // Create img element
      const img = document.createElement("img");
      img.src = imgURL;
      img.width = 128;

      const label = document.createElement("div");
      label.innerText = "SENDING NOW";

      wrapper.appendChild(img);
      wrapper.appendChild(label);
      this.rightImages.prepend(wrapper);

      // Track pending image
      this.pendingImages.push({ file, element: wrapper });
      this.fileCount.innerText = String(this.pendingImages.length);

      // Allow canceling before sending
      wrapper.addEventListener("click", () => this.removePendingImage(file));
    }
    
    
    addImageURL(imgURL) {

      // Create preview container
      const wrapper = document.createElement("div");
      wrapper.classList.add("chefmaster-chat__right__image");

      // Create img element
      const img = document.createElement("img");
      img.src = imgURL;
      img.width = 128;

      wrapper.appendChild(img);
      this.rightImages.prepend(wrapper);
    }

    removePendingImage(file) {
      const index = this.pendingImages.findIndex((f) => f.file === file);
      if (index !== -1) {
        this.pendingImages[index].element.remove();
        this.pendingImages.splice(index, 1);
        this.fileCount.innerText = String(this.pendingImages.length);
      }
    }

    markAllImagesAsSent() {
      this.pendingImages.forEach(({ element }) => {
        element.classList.remove("chefmaster-chat__right__image--sending-now");
        const label = element.querySelector("div");
        if (label) label.remove();
      });
      this.pendingImages = [];
      this.fileCount.innerText = "0";
    }

    updateMessage(messageElement, newText) {
      console.log("updating message", messageElement, newText)
      if (!messageElement) return;
      
      // const existingImages = Array.from(messageElement.querySelectorAll('img'));
      messageElement.innerHTML = newText || "";
      
      // existingImages.forEach(img => {
        // messageElement.appendChild(img);
      // });
      
    }

    // --- Add Message to Chat ---
    addMessage(text, isUser = false, imageUrl = null) {
      const message = this.templateMessage.cloneNode(true);
      const from = this.templateFrom.cloneNode(true);

      message.innerHTML = text || "";
      message.classList.remove("chefmaster-chat__popup__chat__message--template");
      from.classList.remove("chefmaster-chat__popup__chat__from--template");
      if (isUser) {
        message.classList.add("chefmaster-chat__popup__chat__message--right");
        
        from.classList.add("chefmaster-chat__popup__chat__from--right");
        
        from.innerText = "You - now";

        // Append preview thumbnails
        this.pendingImages.forEach(({ file }) => {
          const imgPreview = document.createElement("img");
          imgPreview.width = 64;
          imgPreview.height = 64;
          imgPreview.src = URL.createObjectURL(file);
          message.appendChild(imgPreview);
        });
      } else {
        from.innerText = "E.C. - now";
      }

      if (imageUrl) {
        const img = document.createElement("img");
        img.src = imageUrl;
        img.width = 128;
        message.appendChild(img);
      }

      from.dataset.timestamp = Date.now();
      this.chatContainer.appendChild(message);
      this.chatContainer.appendChild(from);
      this.scrollToBottom();

      return message;
    }

    scrollToBottom() {
      this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
    }

  async fetchResponse(message) {
    this.setLoading(true);

    const formData = new FormData();
    formData.append("sessionId", this.sessionId);
    formData.append("message", message);

    this.pendingImages.forEach(({ file }) => {
      formData.append("images", file);
    });

    //http://chatbot.chefmaster.app

    try {
      const response = await fetch("https://app.bignova.ai/api/chat/1", {
        method: "POST",
        body: formData,
        headers: {
          'Accept': 'text/event-stream',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullContent = '';
      let buffer = '';

      // Add an empty message that we'll update as content streams in
      const messageIndex = this.addMessage('', false, null);
      this.setLoading(false);
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.trim() === '') continue;
          
          if (line.startsWith('data: ')) {
            const data = line.slice(6);
            if (data === '[DONE]') continue;

            try {
              const parsed = JSON.parse(data);
                if(parsed.type == "response.output_text.delta") {
                  const text = parsed.delta

                  if (text) {
                    fullContent += text;
                    this.updateMessage(messageIndex, fullContent);
                  }
                }
              

            } catch (e) {
              console.error('Parse error:', e);
            }
          }
        }
      }

      // Extract image URLs from final content
      const div = document.createElement("div");
      div.innerHTML = fullContent;
      const imageURLs = Array.from(div.querySelectorAll("img")).map((v) => v.src);

      console.log(imageURLs);
      const x = this;
      imageURLs.forEach((v) => x.addImageURL(v));

      // Mark all as sent
      this.markAllImagesAsSent();

    } catch (err) {
      console.error("Chat error:", err);
      this.addMessage("Network error. Please try again later.");
      // Keep pending images for retry or manual deletion
    } finally {
      this.setLoading(false);
    }
  }

    // --- Loading state ---
    setLoading(isActive) {
      if (isActive) {
        this.loading.classList.add("chefmaster-chat__popup__chat__message--active");
        this.sendButton.disabled = true;
        this.textarea.disabled = true;
      } else {
        this.loading.classList.remove("chefmaster-chat__popup__chat__message--active");
        this.sendButton.disabled = false;
        this.textarea.disabled = false;
      }
    }

    // --- Timestamp Updating ---
    startTimestampUpdater() {
      this.templateFrom.dataset.timestamp = Date.now();
      setInterval(() => this.updateTimestamps(), 60000);
    }

    updateTimestamps() {
      this.chatContainer.querySelectorAll(".chefmaster-chat__popup__chat__from").forEach((el) => {
        const [name] = el.innerText.split(" - ");
        el.innerText = `${name} - ${this.timeAgo(parseInt(el.dataset.timestamp))}`;
      });
    }

    // --- Helpers ---
    timeAgo(timestamp1, timestamp2 = Date.now()) {
      const diffMs = Math.abs(timestamp2 - timestamp1);
      const seconds = Math.floor(diffMs / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (seconds < 60) return `${seconds}s ago`;
      if (minutes < 60) return `${minutes}m ago`;
      if (hours < 24) return `${hours}h ago`;
      return `${days}d ago`;
    }

    generateGUID() {
      const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
    }
  }

  // Initialize
  new ChefmasterChat(".chefmaster-chat");
});